__turbopack_context__.v({
  "loaderLogo": "Loder-module__WodBJq__loaderLogo",
});
